import React, { Component } from "react";
import axios from "axios";
import constant from "../../constant";
import RotateImgComp from "../../components/RotateImgComp";
import { LoadingComp } from "../../components/LoadingComp";

import PopupComp from "../../components/PopupComp";

import { connect } from "react-redux";
import { getCurrencyList } from "../../store/actions/currencyActions";

import "./style.scss";

class EditProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 1,
      isImgPopup: false,
      picture: "",
      isCheckedOldPassword: false,
      user: [],
      isLoading: true
    };
  }

  componentDidMount() {
    this.props.getCurrencyList();
    this.user_data();

    let { hash } = this.props.history.location;
    switch (hash) {
      case "#dp":
        return this.handleChange(2, "#dp");
      case "#other":
        return this.handleChange(3, "#other");
      case "#password":
        return this.handleChange(4, "#password");
      default:
        return this.handleChange(1);
    }
  }

  handleChange = (tab, hash = "#") => {
    this.props.history.push(hash);
    this.setState({
      tab
    });
  };

  user_data = () => {
    let { user_id } = this.props;

    axios
      .get(`${constant.phpHost}action/dashboard.php`, {
        params: {
          todo: "user_data",
          en_id: user_id
        }
      })
      .then(res => {
        this.setState({
          user: res.data,
          isLoading: false
        });
      });
  };

  handleSubmit = (e, tab) => {
    e.preventDefault();

    let formData;
    if (tab === 2) {
      formData = new FormData();
    } else {
      formData = new FormData(e.target);
    }

    formData.append("todo", "edit_profile");
    formData.append("en_id", this.props.user_id);

    if (tab === 2) {
      formData.append("picture", this.state.crop_img);
      formData.append("rotation", this.state.rotation);
    }

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        alert("success");

        let OAuth = JSON.parse(localStorage.getItem("O_Auth"));
        if (OAuth) {
          if (tab === 1) {
            if (OAuth.name !== response.data.name) {
              OAuth["name"] = response.data.name;
              window.location.reload();
            }
          }

          if (tab === 2) {
            OAuth["dp"] = response.data.dp;
            this.setState(
              {
                isImgPopup: false
              },
              window.location.reload()
            );
          }

          if (tab === 3) {
            OAuth["currency"] = response.data.currency;
          }

          localStorage.setItem("O_Auth", JSON.stringify(OAuth));
        }

        if (tab === 4) {
          this.setState({
            isCheckedOldPassword: false
          });
          this.myFormRef.reset();
        }

        this.user_data();
      });
  };

  // Profile Image
  handleImageChange = e => {
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        org_img: reader.result,
        crop_img: reader.result,
        isImgPopup: true,
        rotation: 0
      });
    };

    reader.readAsDataURL(file);
  };

  croppers = crop_img => {
    this.setState({
      crop_img
    });
  };

  rotates = (rotation, file) => {
    this.setState({
      rotation,
      file
    });
  };

  handlePopup = () => {
    this.setState({
      isImgPopup: false,
      picture: ""
    });
  };

  // Check Password
  handleCheckPassword = e => {
    e.preventDefault();

    let formData = new FormData(e.target);
    formData.append("todo", "check_password");
    formData.append("en_id", this.props.user_id);

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        alert(response.data);

        let error_pwd = "";
        if (!response.data) {
          error_pwd = "Password did not match";
        }

        this.setState({
          isCheckedOldPassword: response.data,
          error_pwd
        });

        this.myFormRef.reset();
      });
  };

  render() {
    const { isSocial, currency_list } = this.props;
    let { user, tab, isImgPopup, org_img, error_pwd, isLoading } = this.state;

    if (isLoading) {
      return <LoadingComp customStyle={{ padding: "200px 0" }} />;
    }

    return (
      <div>
        {isImgPopup ? (
          <PopupComp isPopup={this.handlePopup}>
            <div className="form-group">
              <h2>Crop Profile!</h2>
              <p>Crop if you need.....</p>
            </div>
            <RotateImgComp
              org_img={org_img}
              crop_img={this.state.crop_img}
              filename={this.state.file_name}
              rotation={this.state.rotation}
              croppers={this.croppers}
              rotates={this.rotates}
            />
            <div className="prev_img">
              <img
                src={this.state.crop_img}
                style={{
                  transform: `rotate(${this.state.rotation}deg)`
                }}
                alt="cropped_image"
              />
              <button type="button" onClick={e => this.handleSubmit(e, 2)}>
                Save changes
              </button>
            </div>
          </PopupComp>
        ) : null}
        <div className="edit-profile">
          <div className="block">
            <div className="left_" id="header_tab2">
              <div className="tab">
                <label
                  className={tab === 1 ? "active" : ""}
                  onClick={() => this.handleChange(1)}
                >
                  <i className="fa fa-info" />
                  General Info
                </label>
                <label
                  className={tab === 2 ? "active" : ""}
                  onClick={() => this.handleChange(2, "#dp")}
                >
                  <i className="fa fa-user-circle-o" />
                  Profile Picture
                </label>
                <label
                  className={tab === 3 ? "active" : ""}
                  onClick={() => this.handleChange(3, "#other")}
                >
                  <i className="fa fa-info-circle" />
                  Other Info
                </label>
                {!isSocial ? (
                  <label
                    className={tab === 4 ? "active" : ""}
                    onClick={() => this.handleChange(4, "#password")}
                  >
                    <i className="fa fa-key" />
                    Change Password
                  </label>
                ) : null}
              </div>
            </div>
            <div className="right_">
              {tab === 1 ? (
                <form onSubmit={e => this.handleSubmit(e, 1)}>
                  <div className="form-block">
                    <div className="rows">
                      <h1>Basic Info</h1>
                      <div className="form-group">
                        <label>Full Name</label>
                        <input
                          type="text"
                          name="name"
                          defaultValue={user.name}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Company</label>
                        <input
                          type="text"
                          name="company"
                          defaultValue={user.company}
                        />
                      </div>
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          defaultValue={user.email}
                        />
                      </div>
                      <div className="form-group">
                        <label>Phone</label>
                        <input
                          type="text"
                          name="phone"
                          defaultValue={user.phone}
                        />
                      </div>
                    </div>
                    <div className="rows">
                      <h1>Address Info</h1>
                      <div className="form-group">
                        <label>Address</label>
                        <input
                          type="text"
                          name="address"
                          defaultValue={user.address}
                        />
                      </div>
                      <div className="form-group">
                        <label>Country</label>
                        <input
                          type="text"
                          name="country"
                          defaultValue={user.country_id}
                        />
                      </div>
                      <div className="form-group">
                        <label>City</label>
                        <input
                          type="text"
                          name="city"
                          defaultValue={user.city_id}
                        />
                      </div>
                      <div className="form-group">
                        <label>Zip</label>
                        <input type="text" name="zip" defaultValue={user.zip} />
                      </div>
                    </div>
                    <div align="right" className="save_btn">
                      <button>Save Info</button>
                    </div>
                  </div>
                </form>
              ) : null}

              {tab === 2 ? (
                <div className="form-block">
                  <div className="rows">
                    <h1>Profile Picture</h1>
                    <div className="form-group">
                      <div className="profile_choose">
                        <i className="fa fa-camera" />
                        <span>Change Photo</span>
                        <input
                          type="file"
                          name="picture"
                          value={this.state.picture}
                          onChange={this.handleImageChange}
                          accept=".jpeg,.jpg,.png"
                        />
                      </div>
                      <img
                        className="profile_dp"
                        src={user.dp}
                        alt=""
                        width="160"
                        height="160"
                      />
                    </div>
                  </div>
                </div>
              ) : null}

              {tab === 3 ? (
                <form onSubmit={e => this.handleSubmit(e, 3)}>
                  <div className="form-block">
                    <div className="rows">
                      <h1>Other Info</h1>
                      <div className="form-group">
                        <label>Currency</label>
                        <select
                          name="def_currency"
                          defaultValue={user.currency}
                        >
                          {currency_list.map((cur, i) => (
                            <option key={i} value={cur.id}>
                              {cur.code}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Instagram ID</label>
                        <input
                          type="text"
                          name="instagram"
                          defaultValue={user.instagram}
                        />
                      </div>
                      <div className="save_btn">
                        <button>Save Info</button>
                      </div>
                    </div>
                  </div>
                </form>
              ) : null}

              {!isSocial ? (
                tab === 4 ? (
                  <div className="form-block">
                    <div className="rows">
                      <h1>Change Password</h1>
                      {this.state.isCheckedOldPassword ? (
                        <form
                          onSubmit={e => this.handleSubmit(e, 4)}
                          ref={e => (this.myFormRef = e)}
                        >
                          <div className="form-group">
                            <label>New Password</label>
                            <input
                              type="password"
                              name="password"
                              placeholder="********"
                            />
                          </div>
                          <div className="save_btn">
                            <button>Reset Password</button>
                          </div>
                        </form>
                      ) : (
                        <form
                          onSubmit={this.handleCheckPassword}
                          ref={e => (this.myFormRef = e)}
                        >
                          <div className="form-group">
                            <label>Old Password</label>
                            <input
                              type="password"
                              name="old_password"
                              placeholder="********"
                            />
                            {error_pwd !== "" ? (
                              <span className="color-red">{error_pwd}</span>
                            ) : null}
                          </div>
                          <div className="save_btn">
                            <button>Verify Password</button>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                ) : null
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currency_list: state.currency.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCurrencyList: () => dispatch(getCurrencyList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);
